'use strict'

import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './VerticalLabel.less'

const COMPONENT_CLASS = 'vertical-label'

const TYPE_TO_CLASS = {
  'normal': '',
  'primary': 'primary',
  'info': 'info'
}

class VerticalLabel extends React.Component {
  /**
   * Returns the type class by the type property
   * @returns {String} - a class name
   */
  getTypeClass () {
    return TYPE_TO_CLASS[this.props.type] || null
  }

  render () {
    const className = classNames(COMPONENT_CLASS, this.getTypeClass())
    return (
      <div className={className}>
        <div className='label-content'>
          {this.props.children}
        </div>
        <div className='label-text'>
          {this.props.label}
        </div>
      </div>
    )
  }
}

VerticalLabel.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(['normal', 'primary', 'info'])
}

export default VerticalLabel



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/VerticalLabel/index.js